import { isHitlEnabled } from "../features/hitl/presentPlan";
import { useFeatureFlags } from "./useFeatureFlags";

export function useHitlEnabled(): boolean {
  const featureFlags = useFeatureFlags();
  return isHitlEnabled(featureFlags);
}
